import React from 'react';

import { SearchState } from '@/AppRedux/actions/booking/bookingType';
import BookingSearchCardDesktop from './BookingSearchCardDesktop';

export type BookingSearchMode = 'mobile' | 'desktop';

export interface BookingSearchCardProps {
  mode: BookingSearchMode;
  propcode?: string;
  onSearchOverride?: (values: SearchState) => void;
}

const BookingSearchCard: React.FC<BookingSearchCardProps> = (props) => {
  return <BookingSearchCardDesktop {...props} />;
};

export default BookingSearchCard;
